import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import { Link, useLocation } from "react-router-dom";

const LInk = styled(Link)`
  width: 100%;
  text-decoration: none;
`;

const DrawerWrapper = styled.div`
  background-color: #ffffff;
  position: absolute;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 0 30px 0;
  left: 0;
  right: 0;
  top: 80px;

  max-height: ${({ toggle }) => (toggle ? "500px" : "0px")};
  opacity: ${({ toggle }) => (toggle ? 1 : 0)};
  transform: ${({ toggle }) =>
    toggle ? "translateY(0)" : "translateY(-20px)"};
  overflow: hidden;
  transition: all 0.4s ease;

  button {
    background-color: inherit;
    border: none;
    width: 100%;
    font-size: 16px;
    font-family: "Neue Machina";
    font-weight: 500;
    height: 50px;
    text-align: center;
    cursor: pointer;
  }
`;

const Container = styled.div`
  display: none;
  @media (max-width: 950px) {
    display: block;
    z-index: 99;
  }
`;
const IconWrapper = styled.div`
  transition: transform 0.6s ease, opacity 0.3s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #928358;
  svg {
    font-size: 32px;
  }
`;

const Drawer = () => {
  const [toggle, setToggle] = useState(false);
  const [color, setColor] = useState("");
  const location = useLocation();
  const drawerRef = useRef(null);

  useEffect(() => {
    switch (location.pathname) {
      case "/contact":
        setColor("contact");
        break;
      case "/about":
        setColor("about");
        break;
      case "/":
        setColor("home");
        break;
      case "/services":
        setColor("services");
        break;
      case "/project":
        setColor("project");
        break;
      default:
        setColor("");
    }
  }, [location.pathname]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setToggle(false);
      }
    }

    function handleScroll() {
      setToggle(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleToggle = () => {
    setToggle((prev) => !prev);
  };

  return (
    <Container>
      <IconWrapper
        onClick={handleToggle}
        style={{
          transform: toggle ? "rotate(180deg)" : "rotate(0deg)",
          opacity: toggle ? 0.8 : 1,
        }}
      >
        {toggle ? (
          <CloseIcon sx={{ color: "black" }} />
        ) : (
          <MenuIcon sx={{ color: "black" }} />
        )}
      </IconWrapper>

      <DrawerWrapper ref={drawerRef} toggle={toggle}>
        <LInk to="/">
          <button
            onClick={handleToggle}
            style={{ color: color === "home" ? "#928358" : "black" }}
            disabled={color === "home"}
          >
            Home
          </button>
        </LInk>
        <LInk to="/about">
          <button
            onClick={handleToggle}
            style={{ color: color === "about" ? "#928358" : "black" }}
            disabled={color === "about"}
          >
            About
          </button>
        </LInk>
        {/* <LInk to="/services">
          <button
            onClick={handleToggle}
            style={{ color: color === "services" ? "#928358" : "black" }}
            disabled={color === "services"}
          >
            Services
          </button>
        </LInk> */}
        <LInk to="/project">
          <button
            onClick={handleToggle}
            style={{ color: color === "project" ? "#928358" : "black" }}
            disabled={color === "project"}
          >
            Projects
          </button>
        </LInk>
        <LInk to="/contact">
          <button
            onClick={handleToggle}
            style={{ color: color === "contact" ? "#928358" : "black" }}
            disabled={color === "contact"}
          >
            Contact
          </button>
        </LInk>
      </DrawerWrapper>
    </Container>
  );
};

export default Drawer;
